import React from 'react';
import { Grid } from '@mui/material';
import TestHistoryCard from '../TestHistoryCard';

export default function TestHistoryResultsGrid({ results = [], onCardClick }) {
  return (
    <Grid container spacing={3}>
      {results.map((result) => (
        <Grid item xs={12} sm={6} md={4} key={result.id}>
          <TestHistoryCard result={result} onClick={onCardClick} />
        </Grid>
      ))}
    </Grid>
  );
}
